import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth.service';
import { GlobalErrorsHandler } from 'src/app/core/errors/global-errors.handler';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {
  constructor(private auth: AuthService, private router: Router, private errorsHandler: GlobalErrorsHandler) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.startsWith('api')) {
      // Load user token and add it to headers
      const token = this.auth.authToken;

      if (!token || req.headers.has('Authorization')) {
        return next.handle(req);
      }

      req = req.clone({
        setHeaders: { Authorization: token }
      });

      return next.handle(req).pipe(
        switchMap(res => {
          const error = res instanceof HttpResponse && res.body && res.body.success === false ? res.body : null;

          if (error && error.code === -2) { // InvalidAuth
            this.auth.logout();
            this.router.navigateByUrl('/login');
            return throwError(res);
          }

          return of(res);
        }),
        catchError(err => {
          if (err instanceof HttpErrorResponse && err.status === 401) { // Unauthorized
            this.auth.logout();
            this.router.navigateByUrl('/login');
            return throwError(err);
          }

          return throwError(err);
        })
      );
    } else {
      return next.handle(req);
    }
  }
}
